import React from 'react';
import { UserProfile } from '@clerk/clerk-react';
import Layout from '../components/Layout';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

const clerkAppearance = {
  variables: {
    colorPrimary: '#1E4FBE',
    fontFamily: FONT,
    borderRadius: '8px',
  },
  elements: {
    rootBox: { width: '100%' },
    cardBox: {
      width: '100%',
      boxShadow: '0 1px 3px rgba(16,22,35,0.06), 0 1px 2px rgba(16,22,35,0.04)',
      border: '1px solid #D7DCE4',
      borderRadius: '12px',
    },
  },
};

function AccountPage() {
  return (
    <Layout>
      <div style={{ padding: '36px 40px 48px', maxWidth: 'calc(880px + 80px)', fontFamily: FONT }}>
        <h1 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 700, color: '#101623', letterSpacing: '-0.011em' }}>Konto</h1>
        <p style={{ margin: '0 0 32px', fontSize: 13, color: '#8A93A3' }}>Profil, Sicherheit und Abonnement verwalten</p>
        <UserProfile routing="path" path="/account" appearance={clerkAppearance} />
      </div>
    </Layout>
  );
}

export default AccountPage;
